
export const calcularTotalesPorCategoria = (categoriaData, year_list) => {
  const resultado = {};

  for (let i = 0; i < year_list.length; i++) {
    const year = year_list[i];

    resultado[year] = {
      ejecutado: 0,
      presupuestado: 0,
      variacion: 0,
    };

    if (Array.isArray(categoriaData)) {
      for (let j = 0; j < categoriaData.length; j++) {
        const fila = categoriaData[j];
        const yearData = fila && fila[year] ? fila[year] : {};

        resultado[year].presupuestado += parseFloat(yearData.presupuestado || 0);
        resultado[year].ejecutado += parseFloat(yearData.ejecutado || 0);
        resultado[year].variacion += parseFloat(yearData.variacion || 0);
      }
    }
  }

  return resultado;
};

export const calcularTotalesConSigno = (categoriaData, getSign, year_list) => {
  const resultado = {};

  for (let i = 0; i < year_list.length; i++) {
    const year = year_list[i];
    resultado[year] = {
      ejecutado: 0,
      presupuestado: 0,
      variacion: 0,
    };
  }

  if (Array.isArray(categoriaData)) {
    for (let j = 0; j < categoriaData.length; j++) {
      const fila = categoriaData[j];
      const signo = getSign(fila);

      for (let i = 0; i < year_list.length; i++) {
        const year = year_list[i];
        const yearData = fila && fila[year] ? fila[year] : {};

        resultado[year].presupuestado += signo * parseFloat(yearData.presupuestado || 0);
        resultado[year].ejecutado += signo * parseFloat(yearData.ejecutado || 0);
        resultado[year].variacion += signo * parseFloat(yearData.variacion || 0);
      }
    }
  }

  return resultado;
};
